module.exports = __webpack_public_path__ + "d6291f88056601e360ce6cea4bf676f4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Bold/OpenSans-Bold.svg?v=1.1.0
// module id = 1006
// module chunks = 0